import React, { useState, useEffect, useRef } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    IconButton,
    Button,
    Link,
    Box,
    Alert,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useContent } from '../../../../context/ContentContext';

const PasswordDialog = ({ open, onClose, onSubmit, error }) => {
    const { fetchUserData, sendForgotPasswordBankRequest, Username } = useContent();
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [alert, setAlert] = useState({ type: '', message: '' }); // Alert state

    const passwordInputRef = useRef(null);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleForgotPassword = async () => {
        try {
            setAlert({ type: '', message: '' }); // Reset alert

            console.log("Fetching user data...");
            const phone = await fetchUserData(); // Directly fetch phone number
            console.log("User phone fetched successfully:", phone);

            if (!phone) {
                throw new Error("Nomor telepon tidak tersedia. Silakan perbarui profil Anda.");
            }

            // Send forgot password request if phone number is available
            console.log("Sending forgot password request...");
            await sendForgotPasswordBankRequest(phone); // Pass the phone number directly
            console.log("Forgot password request sent successfully.");

            // Show success alert
            setAlert({ type: 'success', message: 'Permintaan reset password berhasil dikirim!' });
        } catch (err) {
            console.error("Error during password recovery:", err.message);

            // Show error alert
            setAlert({ type: 'error', message: err.message || 'Terjadi kesalahan saat memproses permintaan.' });
        }
    };



    const handleSubmit = async (event) => {
        event.preventDefault();
        if (password) {
            await onSubmit(password);
        }
    };

    useEffect(() => {
        if (open && passwordInputRef.current) {
            passwordInputRef.current.focus();
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Silahkan masukkan kata sandi</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <input type="text" style={{ display: 'none' }} name="username" autoComplete="username" />
                    <TextField
                        label="Kata Sandi"
                        type={showPassword ? 'text' : 'password'}
                        fullWidth
                        variant="outlined"
                        value={password}
                        onChange={handlePasswordChange}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        margin="normal"
                        autoComplete="new-password"
                        inputRef={passwordInputRef}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <>
                                        <IconButton
                                            onClick={handleShowPassword}
                                            edge="end"
                                            sx={{
                                                background: 'transparent',
                                                border: 'none',
                                                '&:hover': {
                                                    background: 'transparent',
                                                },
                                            }}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </>
                                ),
                            },
                        }}
                        helperText={typeof error === 'string' ? error : (error && error.message ? error.message : '')} // Ensure helperText is a string or empty
                        error={Boolean(error)}
                    />

                    <Box display="flex" justifyContent="flex-end" mb={2}>
                        <Link
                            onClick={handleForgotPassword}
                            style={{ cursor: 'pointer', fontSize: '14px', color: '#1976d2' }}
                        >
                            Lupa Password?
                        </Link>
                    </Box>

                    {alert.message && (
                        <Alert severity={alert.type} onClose={() => setAlert({ type: '', message: '' })}>
                            {alert.message}
                        </Alert>
                    )}

                    <DialogActions>
                        <Button onClick={onClose} color="secondary">
                            Cancel
                        </Button>
                        <Button type="submit" color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default PasswordDialog;
